import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-description-dialog',
    templateUrl: './description-dialog.component.html',
    styleUrls: ['./description-dialog.component.scss'],
    standalone: false
})
export class DescriptionDialogComponent {

    public textareaValue = '';

    @Output() onTextAreaSubmit = new EventEmitter<string>();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { 
            title: string, 
            description: string,
            descriptionTitle: string,
            textareaValue: string,
            textareaPlaceholder: string,
            textareaSubTitle: string,
            extensionButtonText: string,
            closeButtonText: string,
            extensionButtonLeft: boolean,
        },
        private dialogRef: MatDialogRef<DescriptionDialogComponent>
    ) {}

    onTextAreaChange(value: string): void {
        this.textareaValue = value;
    }

    onCloseButtonClick(): void {
        this.dialogRef.close();
    }

    onSubmit(e: SubmitEvent) {
        e.preventDefault();
        this.onTextAreaSubmit.emit(this.textareaValue);
        this.dialogRef.close();
    }
}
